import React from 'react';
import classNames from 'classnames';

export interface RadiobuttonProps extends React.HTMLProps<HTMLInputElement> {
  id?: string;
  className?: string;
  label?: string;
}

const Radiobutton: React.FC<RadiobuttonProps> = (props: RadiobuttonProps) => {
  const { id, className, label, checked, onChange, ...inputProps } = props;

  const radiobtnClass = classNames(className, 'ui-radiobutton');

  return (
    <label htmlFor={id} className={radiobtnClass}>
      {label && <span className="ui-radiobutton_label">{label}</span>}
      <input
        type="radio"
        name={id}
        checked={checked}
        onChange={onChange}
        {...inputProps}
      />
      <span className="ui-radiobutton_checkmark" />
    </label>
  );
};

export default Radiobutton;
